import React from "react";

/*
 * Plain page bar used by the fee and payment lists.
 *
 * Kept deliberately small: it takes the pagination block the API already
 * returns and calls back with a page number. Nothing else in the app has to
 * know how paging works.
 */
const Paging = ({ pagination, onPage }) => {
  if (!pagination || pagination.pages <= 1) {
    // Still worth telling the user how many rows there are.
    return pagination && pagination.total ? (
      <div class="text-muted mb-3">{pagination.total} record(s)</div>
    ) : null;
  }

  const { page, pages, total, per_page: perPage } = pagination;
  const first = (page - 1) * perPage + 1;
  const last = Math.min(page * perPage, total);

  // Show at most 7 page buttons, centred on the current page.
  const start = Math.max(1, Math.min(page - 3, pages - 6));
  const end = Math.min(pages, start + 6);
  const numbers = [];
  for (let i = start; i <= end; i++) numbers.push(i);

  return (
    <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
      <div class="text-muted">
        Showing {first} to {last} of {total}
      </div>
      <div>
        <button
          class="btn btn-sm btn-comman mr-1"
          type="button"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
        >
          Prev
        </button>
        {start > 1 && (
          <button
            class="btn btn-sm btn-comman mr-1"
            type="button"
            onClick={() => onPage(1)}
          >
            1
          </button>
        )}
        {numbers.map((n) => (
          <button
            key={n}
            class={n === page ? "btn btn-sm btn-Next mr-1" : "btn btn-sm btn-comman mr-1"}
            type="button"
            onClick={() => onPage(n)}
          >
            {n}
          </button>
        ))}
        {end < pages && (
          <button
            class="btn btn-sm btn-comman mr-1"
            type="button"
            onClick={() => onPage(pages)}
          >
            {pages}
          </button>
        )}
        <button
          class="btn btn-sm btn-comman"
          type="button"
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Paging;
